import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import type { ICurrenciesResponse } from "@api/geo/currencies/types";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICurrenciesResponse>>,
  IPathBaseParam,
  IPaginationParams
>("geo.currencies");
const getApis = createGetApi<
  IApiResponse<ICurrenciesResponse>,
  IPathByIdParam,
  object
>("geo.currencies");

export const currencies = {
  ...getAllApis,
  ...getApis,
};
